import { httpRequest } from '../lib/utils/httpClient';
import { statusRequestService } from './../../../../../shared_lib/src/shared/statusrequests/statusRequestService';
import { statusRequestHooks } from './../../../../../shared_lib/src/shared/statusrequests/statusRequestHook';

export const statusRequestServiceInstance = statusRequestService(httpRequest);
export const statusRequestHooksInstance = statusRequestHooks(
  statusRequestServiceInstance
);

export const {
  useCancelConsultMetadata,
  useSaveCancelConsult,
  useCompleteDDLDetails,
  useCompleteConsult,
  useSaveOnHoldConsult,
  useOnHoldConsultMetadata,
} = statusRequestHooksInstance;
